"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserServiceStub = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const faker = __importStar(require("faker"));
const fakeUserProfile = {
    _id: faker.random.uuid(),
    salutation: faker.name.prefix(),
    familyName: faker.name.lastName(),
    firstName: faker.name.lastName(),
    emails: [
        {
            email: faker.internet.email(),
            isPrimary: faker.random.boolean(),
            isVerified: faker.random.boolean(),
        },
    ],
    phones: [
        {
            iso2: faker.address.countryCode(),
            dialCode: faker.phone.phoneNumber(),
            phoneNumber: faker.phone.phoneNumber(),
            isPrimary: faker.random.boolean(),
            isVerified: faker.random.boolean(),
        },
    ],
    username: faker.random.uuid(),
    birthDetails: {
        dob: faker.date.past(20),
        birthPlace: faker.address.city(),
        birthCountry: faker.address.country(),
    },
    kycDetails: {
        isKYCDone: faker.random.boolean(),
        address: {
            // flatNumber: faker.address.secondaryAddress(),
            description: "987/12345 Street St, QLD, AU",
            flatNumber: "987",
            streetNumber: "12345",
            streetName: faker.address.streetName(),
            suburb: faker.address.city(),
            postcode: faker.address.zipCode(),
            // state: faker.address.state(),
            state: "QLD",
            // country: faker.address.country(),
            country: "AU",
        },
        verificationId: "",
        verificationToken: "",
    },
    companyIds: faker.random.boolean() ? [faker.random.uuid()] : [faker.random.uuid(), faker.random.uuid()],
    onboardingStatus: [
        mystake_common_sdk_1.CompanyListItemStatus.ReadyForReview,
        mystake_common_sdk_1.CompanyListItemStatus.KYCPending,
        mystake_common_sdk_1.CompanyListItemStatus.SetUpInProgress,
        mystake_common_sdk_1.CompanyListItemStatus.AddPaymentMethod,
    ][faker.random.number({ min: 0, max: 3 })],
    isInvestor: faker.random.boolean(),
    isExternalInvestor: faker.random.boolean(),
    roles: [mystake_common_sdk_1.Roles.ADMIN],
    rolesByCompany: [
        {
            companyId: faker.random.uuid(),
            roles: [mystake_common_sdk_1.Roles.ADMIN],
        },
    ],
    nomineeCompanies: [],
    lastLogin: new Date(2019, 2, 18),
};
class UserServiceStub {
    async isNominee() {
        return { isNominee: faker.random.boolean(), nomineeForCompanyIds: [] };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async updateKycDoneStatus(_body) {
        return faker.random.boolean();
    }
    async getUser() {
        return fakeUserProfile;
    }
    async getUserById(userId) {
        if (userId) {
            return Promise.resolve(fakeUserProfile);
        }
        return Promise.resolve(fakeUserProfile);
    }
    async updateUserPrimaryPhone(phoneDetails) {
        if (phoneDetails) {
            return faker.random.boolean();
        }
        return false;
    }
    async isEmailExists(email) {
        if (email) {
            return faker.random.boolean();
        }
        return false;
    }
    async isAcnExists(acn) {
        if (acn) {
            return faker.random.boolean();
        }
        return false;
    }
    async updateEmail(email) {
        if (email) {
            return faker.internet.email();
        }
        return null;
    }
    async updateDobAddress(dobAddressData) {
        if (dobAddressData) {
            return faker.random.boolean();
        }
        return false;
    }
    async removePreKycDetails() {
        return faker.random.boolean();
    }
    updateKycDetails(updateKycDetailsData) {
        if (updateKycDetailsData) {
            return Promise.resolve(faker.random.boolean());
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject(false);
    }
    updateAddressDetails(updateAddressDetailsData) {
        if (updateAddressDetailsData) {
            return Promise.resolve(faker.random.boolean());
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject(false);
    }
    async requestPasswordReset(requestPasswordResetRequestBody) {
        if (requestPasswordResetRequestBody) {
            return faker.random.boolean()
                ? Promise.resolve({
                    status: true,
                    message: "Password Reset Email Sent",
                    payload: null,
                })
                : // eslint-disable-next-line prefer-promise-reject-errors
                    Promise.reject({
                        status: false,
                        message: "User doesn't exist or Failed to send password reset email",
                        payload: null,
                    });
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
            status: false,
            message: "Request body is required",
        });
    }
    async setNewPassword(authToken, setNewPasswordRequestBody) {
        if (authToken && setNewPasswordRequestBody) {
            if (setNewPasswordRequestBody.password === setNewPasswordRequestBody.confirmPassword) {
                return Promise.resolve({
                    status: true,
                    message: "Password updated!",
                    payload: null,
                });
            }
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({
                status: false,
                message: "Passwords must match!",
                payload: null,
            });
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
            status: false,
            message: "Failed to update password",
            payload: null,
        });
    }
    async verifyThenUpdateMobileNumber(verifyThenUpdateMobileNumberRequestBody) {
        if (verifyThenUpdateMobileNumberRequestBody) {
            return faker.random.boolean()
                ? Promise.resolve({
                    status: true,
                    message: "Successfully verified and updated mobile number",
                    payload: null,
                })
                : // eslint-disable-next-line prefer-promise-reject-errors
                    Promise.reject({
                        status: false,
                        message: "Invalid code",
                        payload: null,
                    });
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({ status: false, message: "Invalid request" });
    }
    async linkNomineeExistingAccount(linkNomineeExistingAccountRequestBody) {
        if (linkNomineeExistingAccountRequestBody) {
            Promise.resolve({
                status: true,
                message: "Account linked successfully to company XYZ Pty. Ltd.",
                payload: null,
            });
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
            status: false,
            message: "Invalid request",
            payload: null,
        });
    }
    async updateLastLogin(username) {
        if (username) {
            return faker.random.boolean();
        }
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async getUserCompanies() {
        return {
            status: true,
            message: "Successfully got companies",
            payload: null,
        };
    }
    async grantShareholderRole(companyId, role) {
        if (companyId && role) {
            return {
                status: true,
                message: "Successfully granted Shareholder role access",
                payload: fakeUserProfile.rolesByCompany[0],
            };
        }
        return {
            status: false,
            message: "Failed to grant Shareholder role access",
            payload: null,
        };
    }
    async getInvestorProfiles(companyId, filterByCompany, status, keyword, page, rowsPerPage, sortBy, sortOrder) {
        if (companyId && filterByCompany && status && page && rowsPerPage && sortBy && sortOrder && keyword) {
            const userInvestorData = {};
            return {
                status: true,
                message: "Succesfully fetched user investor profiles",
                payload: userInvestorData,
            };
        }
        return {
            status: false,
            message: "Failed to fetch user investor profiles",
            payload: null,
        };
    }
}
exports.UserServiceStub = UserServiceStub;
//# sourceMappingURL=UserServiceStub.js.map